export const GOOGLE_EVENTS = {
  COPY_BUTTON_CLICK: 'copy_button_click',
  LIVE_STREAM_CLICK: 'live_stream_click',
  LIVE_VIEWER: 'live_viewer',
  SEARCH_SUBMIT: 'search_submit',
  SEARCH_TAG_CLICK: 'search_tag_click',
  SHARE_BUTTON_CLICK: 'share_button_click',
} as const;
